<div class="grid gap-3 lg:grid-cols-2">
  @for (component of components(); track componentTrackFn(component, $index)) {
    <article class="flex gap-3 rounded-md border border-white bg-white p-3">
      @if (isNotNil(component.featuredFile)) {
        <div class="shrink-0">
          <app-image-thumbnail size="sm">
            <img
              [fill]="true"
              [ngSrc]="component.featuredFile.url"
              [alt]="component.featuredFile.alt" />
          </app-image-thumbnail>
        </div>
      }

      <div class="flex flex-1 flex-col gap-2">
        <div class="flex items-start justify-between gap-3">
          <div class="flex flex-col">
            @if (component.sourceName) {
              <div
                class="text-xs font-semibold tracking-[0.08em] text-gray-500 uppercase">
                {{ component.sourceName }}
              </div>
            }

            <div class="font-semibold">
              {{ component.name }}
            </div>
          </div>

          <div class="text-xs text-gray-500">x {{ component.quantity }} szt.</div>
        </div>

        @if (component.attributes.length) {
          <div class="flex flex-col gap-1 text-sm">
            @for (attribute of component.attributes; track attribute.id) {
              <div class="flex gap-1">
                <span class="font-medium">{{ attribute.label }}:</span>
                <span>{{ attribute.value }}</span>
              </div>
            }
          </div>
        }
      </div>
    </article>
  }
</div>
